/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	function webpackJsonpCallback(data) {
/******/ 		var chunkIds = data[0];
/******/ 		var moreModules = data[1];
/******/ 		var executeModules = data[2];
/******/
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(data);
/******/
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 		// add entry modules from loaded chunk to deferred list
/******/ 		deferredModules.push.apply(deferredModules, executeModules || []);
/******/
/******/ 		// run deferred modules when all chunks ready
/******/ 		return checkDeferredModules();
/******/ 	};
/******/ 	function checkDeferredModules() {
/******/ 		var result;
/******/ 		for(var i = 0; i < deferredModules.length; i++) {
/******/ 			var deferredModule = deferredModules[i];
/******/ 			var fulfilled = true;
/******/ 			for(var j = 1; j < deferredModule.length; j++) {
/******/ 				var depId = deferredModule[j];
/******/ 				if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 			}
/******/ 			if(fulfilled) {
/******/ 				deferredModules.splice(i--, 1);
/******/ 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 			}
/******/ 		}
/******/
/******/ 		return result;
/******/ 	}
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 	// Promise = chunk loading, 0 = chunk loaded
/******/ 	var installedChunks = {
/******/ 		36: 0
/******/ 	};
/******/
/******/ 	var deferredModules = [];
/******/
/******/ 	// script path function
/******/ 	function jsonpScriptSrc(chunkId) {
  /******/ 		return __webpack_require__.p + "" + ({"0":"vendors-DynamicBlogPosts-DynamicFeaturedCollection-DynamicProduct-DynamicTwitterFeed-StaticCollectio-0ac4f36c","1":"DynamicFeaturedCollection-DynamicProduct-StaticCollection-StaticProduct-StaticProductRecommendations-724f8050","2":"vendors-DynamicFeaturedCollection-DynamicProduct-StaticCollection-StaticProduct-StaticProductRecomme-e656a3da","3":"DynamicFeaturedCollection-StaticCollection-StaticProductRecommendations-StaticSearch","4":"DynamicSearch-StaticHeader","5":"vendors-DynamicSearch-StaticHeader","6":"Account","7":"Contact","8":"ContainSwatchTooltips","9":"DynamicBlogPosts","10":"DynamicFeaturedCollection","11":"DynamicMenuList","12":"DynamicNewsletter","13":"DynamicProduct","14":"DynamicPromoBlocks","15":"DynamicRichText","16":"DynamicSearch","17":"DynamicTwitterFeed","18":"DynamicVideo","19":"GiftCard","20":"PXSMap","21":"Page","22":"StaticAnnouncement","23":"StaticArticle","24":"StaticBlog","25":"StaticCart","26":"StaticCollection","27":"StaticFooter","28":"StaticHeader","29":"StaticHighlightsBanners","30":"StaticPassword","31":"StaticProduct","32":"StaticProductRecommendations","33":"StaticRecentlyViewed","34":"StaticSearch","35":"StaticSlideshow","37":"vendors-StaticCart"}[chunkId]||chunkId) + ".bundle.js"
  /******/ 	}
  /******/
  /******/ 	// script path function
  /******/ 	function jsonpScriptSrc(chunkId) {
  /******/ 	  var bundles = { '0': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/vendors-DynamicBlogPosts-DynamicFeaturedCollection-DynamicProduct-DynamicTwitterFeed-StaticCollectio-0ac4f36c.bundle.js?v=112736978312410000281695157359','1': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicFeaturedCollection-DynamicProduct-StaticCollection-StaticProduct-StaticProductRecommendations-724f8050.bundle.js?v=63375057436476591251695157357','2': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/vendors-DynamicFeaturedCollection-DynamicProduct-StaticCollection-StaticProduct-StaticProductRecomme-e656a3da.bundle.js?v=33805050261486279961695157359','3': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicFeaturedCollection-StaticCollection-StaticProductRecommendations-StaticSearch.bundle.js?v=26075949400326773241695157357','4': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicSearch-StaticHeader.bundle.js?v=172976106756392757031695157358','5': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/vendors-DynamicSearch-StaticHeader.bundle.js?v=39810280475065473861695157359','6': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/Account.bundle.js?v=137997421841421319641695157357','7': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/Contact.bundle.js?v=146415540018199060011695157357','8': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/ContainSwatchTooltips.bundle.js?v=110444684164169359151695157357','9': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicBlogPosts.bundle.js?v=52972644053800789691695157357','10': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicFeaturedCollection.bundle.js?v=120086190535090156001695157357','11': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicMenuList.bundle.js?v=100321048458765864411695157358','12': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicNewsletter.bundle.js?v=53839455366887913551695157358','13': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicProduct.bundle.js?v=30270314240725217561695157358','14': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicPromoBlocks.bundle.js?v=85669502040476628161695157358','15': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicRichText.bundle.js?v=70405535324726863791695157358','16': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicSearch.bundle.js?v=156598444984385467841695157358','17': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicTwitterFeed.bundle.js?v=64837741084622429711695157358','18': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/DynamicVideo.bundle.js?v=150054447458013817731695157358','19': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/GiftCard.bundle.js?v=136114867883221282491695157358','20': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/PXSMap.bundle.js?v=45387401502934308121695157358','21': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/Page.bundle.js?v=182485761660644165071695157358','22': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticAnnouncement.bundle.js?v=130322171909959138961695157358','23': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticArticle.bundle.js?v=30601338510525533571695157358','24': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticBlog.bundle.js?v=31482531453572335851695157358','25': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticCart.bundle.js?v=166501169549375011681695157358','26': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticCollection.bundle.js?v=174160874139665567061695157358','27': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticFooter.bundle.js?v=44844614232030129631695157358','28': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticHeader.bundle.js?v=120252563127877080221695157358','29': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticHighlightsBanners.bundle.js?v=1176805868905855231695157358','30': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticPassword.bundle.js?v=111369668518460423401695157358','31': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticProduct.bundle.js?v=175100392279899895721695157358','32': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticProductRecommendations.bundle.js?v=150250268560830479711695157358','33': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticRecentlyViewed.bundle.js?v=44613387037768734511695157358','34': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticSearch.bundle.js?v=52228693430129002741695157358','35': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/StaticSlideshow.bundle.js?v=19594871835131253531695157358','37': '//www.savoryspiceshop.com/cdn/shop/t/227/assets/vendors-StaticCart.bundle.js?v=122160855247282482591695157359' };
  /******/ 	  return bundles[chunkId];
  /******/ 	}
  /******/
  /******/ 	// The require function
  /******/ 	function __webpack_require__(moduleId) {
  /******/
  /******/ 		// Check if module is in cache
  /******/ 		if(installedModules[moduleId]) {
  /******/ 			return installedModules[moduleId].exports;
  /******/ 		}
  /******/ 		// Create a new module (and put it into the cache)
  /******/ 		var module = installedModules[moduleId] = {
  /******/ 			i: moduleId,
  /******/ 			l: false,
  /******/ 			exports: {}
  /******/ 		};
  /******/
  /******/ 		// Execute the module function
  /******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
  /******/
  /******/ 		// Flag the module as loaded
  /******/ 		module.l = true;
  /******/
  /******/ 		// Return the exports of the module
  /******/ 		return module.exports;
  /******/ 	}
  /******/
  /******/ 	// This file contains only the entry chunk.
  /******/ 	// The chunk loading function for additional chunks
  /******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
  /******/ 		var promises = [];
  /******/
  /******/
  /******/ 		// JSONP chunk loading for javascript
  /******/
  /******/ 		var installedChunkData = installedChunks[chunkId];
  /******/ 		if(installedChunkData !== 0) { // 0 means "already installed".
  /******/
  /******/ 			// a Promise means "currently loading".
  /******/ 			if(installedChunkData) {
  /******/ 				promises.push(installedChunkData[2]);
  /******/ 			} else {
  /******/ 				// setup Promise in chunk cache
  /******/ 				var promise = new Promise(function(resolve, reject) {
  /******/ 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
  /******/ 				});
  /******/ 				promises.push(installedChunkData[2] = promise);
  /******/
  /******/ 				// start chunk loading
  /******/ 				var script = document.createElement('script');
  /******/ 				var onScriptComplete;
  /******/
  /******/ 				script.charset = 'utf-8';
  /******/ 				script.timeout = 120;
  /******/ 				if (__webpack_require__.nc) {
  /******/ 					script.setAttribute("nonce", __webpack_require__.nc);
  /******/ 				}
  /******/ 				script.src = jsonpScriptSrc(chunkId);
  /******/
  /******/ 				// create error before stack unwound to get useful stacktrace later
  /******/ 				var error = new Error();
  /******/ 				onScriptComplete = function (event) {
  /******/ 					// avoid mem leaks in IE.
  /******/ 					script.onerror = script.onload = null;
  /******/ 					clearTimeout(timeout);
  /******/ 					var chunk = installedChunks[chunkId];
  /******/ 					if(chunk !== 0) {
  /******/ 						if(chunk) {
  /******/ 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
  /******/ 							var realSrc = event && event.target && event.target.src;
  /******/ 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
  /******/ 							error.name = 'ChunkLoadError';
  /******/ 							error.type = errorType;
  /******/ 							error.request = realSrc;
  /******/ 							chunk[1](error);
  /******/ 						}
  /******/ 						installedChunks[chunkId] = undefined;
  /******/ 					}
  /******/ 				};
  /******/ 				var timeout = setTimeout(function(){
  /******/ 					onScriptComplete({ type: 'timeout', target: script });
  /******/ 				}, 120000);
  /******/ 				script.onerror = script.onload = onScriptComplete;
  /******/ 				document.head.appendChild(script);
  /******/ 			}
  /******/ 		}
  /******/ 		return Promise.all(promises);
  /******/ 	};
  /******/
  /******/ 	// expose the modules object (__webpack_modules__)
  /******/ 	__webpack_require__.m = modules;
  /******/
  /******/ 	// expose the module cache
  /******/ 	__webpack_require__.c = installedModules;
  /******/
  /******/ 	// define getter function for harmony exports
  /******/ 	__webpack_require__.d = function(exports, name, getter) {
  /******/ 		if(!__webpack_require__.o(exports, name)) {
  /******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
  /******/ 		}
  /******/ 	};
  /******/
  /******/ 	// define __esModule on exports
  /******/ 	__webpack_require__.r = function(exports) {
  /******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
  /******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
  /******/ 		}
  /******/ 		Object.defineProperty(exports, '__esModule', { value: true });
  /******/ 	};
  /******/
  /******/ 	// create a fake namespace object
  /******/ 	// mode & 1: value is a module id, require it
  /******/ 	// mode & 2: merge all properties of value into the ns
  /******/ 	// mode & 4: return value when already ns object
  /******/ 	// mode & 8|1: behave like require
  /******/ 	__webpack_require__.t = function(value, mode) {
  /******/ 		if(mode & 1) value = __webpack_require__(value);
  /******/ 		if(mode & 8) return value;
  /******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
  /******/ 		var ns = Object.create(null);
  /******/ 		__webpack_require__.r(ns);
  /******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
  /******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
  /******/ 		return ns;
  /******/ 	};
  /******/
  /******/ 	// getDefaultExport function for compatibility with non-harmony modules
  /******/ 	__webpack_require__.n = function(module) {
  /******/ 		var getter = module && module.__esModule ?
  /******/ 			function getDefault() { return module['default']; } :
  /******/ 			function getModuleExports() { return module; };
  /******/ 		__webpack_require__.d(getter, 'a', getter);
  /******/ 		return getter;
  /******/ 	};
  /******/
  /******/ 	// Object.prototype.hasOwnProperty.call
  /******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
  /******/
  /******/ 	// __webpack_public_path__
  /******/ 	__webpack_require__.p = "";
  /******/
  /******/ 	// on error function for async loading
  /******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
  /******/
  /******/ 	var jsonpArray = window["wpJsonpPaskit"] = window["wpJsonpPaskit"] || [];
  /******/ 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
  /******/ 	jsonpArray.push = webpackJsonpCallback;
  /******/ 	jsonpArray = jsonpArray.slice();
  /******/ 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
  /******/ 	var parentJsonpFunction = oldJsonpFunction;
  /******/
  /******/
  /******/ 	// add entry module to deferred list
  /******/ 	deferredModules.push([7,38]);
  /******/ 	// run deferred modules when ready
  /******/ 	return checkDeferredModules();
  /******/ })
  /************************************************************************/
  /******/ ([
  /* 0 */,
  /* 1 */,
  /* 2 */,
  /* 3 */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setupRippleEffect; });
  /* harmony import */ var _material_ripple__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
   // This function sets up the ripple effect for the various buttons throughout the
  // theme using CSS selectors.
  
  var setupRippleEffect = function setupRippleEffect(rootElement) {
    if ('reduceAnimations' in document.body.dataset) {
      return;
    }
  
    var rippleElements = ['.button-primary', '.button-secondary', '.product-form--atc-button', '.mobile-nav-content .navmenu-link', '.mobile-nav-content .navmenu-button', '.live-search-button', '.form-options-selectable-boxes .option-value-name'];
    rootElement.querySelectorAll(rippleElements.join(',')).forEach(function (el) {
      if (!el.classList.contains('disabled') && !el.hasAttribute('disabled')) {
        el.classList.add('mdc-ripple-surface');
        _material_ripple__WEBPACK_IMPORTED_MODULE_0__[/* MDCRipple */ "a"].attachTo(el);
      }
    });
  };
  
  /***/ }),
  /* 4 */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initLoadInAnimationsAutoplay; });
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return playLoadInAnimations; });
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return resetLoadInAnimations; });
  /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return removeLoadInAnimationsAutoplay; });
  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
  
  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  
  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
  
  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
  
  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
  
  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
  
  var classes = {
    block: 'pxu-lia-block',
    element: 'pxu-lia-element',
    playBlock: 'pxu-lia-block--play',
    resetBlock: 'pxu-lia-block--reset',
    playSection: 'pxu-lia-section--play',
    resetSection: 'pxu-lia-section--reset'
  };
  var mappingSelector = '[type="application/pxs-animation-mapping+json"]';
  /**
   * Find common parent of this block and the closest animation mapping block.
   *
   * @param {HTMLElement} node Block from which to begin search.
   */
  
  var getMappingParentFromBlock = function getMappingParentFromBlock(_ref) {
    var parentNode = _ref.parentNode;
    return parentNode.querySelector(mappingSelector) ? parentNode : getMappingParentFromBlock(parentNode);
  };
  
  var reset = function reset(block, elements) {
    block.style.animationName = 'none';
    block.classList.add(classes.resetBlock);
    elements.forEach(function (element) {
      element.style.animationName = 'none';
    });
  };
  
  var removeReset = function removeReset(block, elements) {
    block.style.animationName = '';
    block.classList.remove(classes.resetBlock);
    elements.forEach(function (element) {
      element.style.animationName = '';
    });
  };
  
  var play = function play(block, elements) {
    block.style.animationPlayState = 'running';
    block.classList.add(classes.playBlock);
    elements.forEach(function (element) {
      element.style.animationPlayState = 'running';
    });
  };
  
  var pause = function pause(block, elements) {
    block.style.animationPlayState = '';
    block.classList.remove(classes.playBlock);
    elements.forEach(function (element) {
      element.style.animationPlayState = '';
    });
  };
  /**
   * Play, or reset animations for a collection of blocks.
   *
   * @param {[HTMLElement]} blocks Blocks to process
   * @param {String} state One of 'play' or 'reset'.
   */
  
  
  var loadInAnimations = function loadInAnimations(blocks) {
    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'play';
    var callNextFrame = [];
  
    if (state === 'reset') {
      blocks.forEach(function (block) {
        var elements = block.querySelectorAll(".".concat(classes.element));
        pause(block, elements);
        reset(block, elements);
        callNextFrame.push(function () {
          removeReset(block, elements);
        });
      });
      var section = getMappingParentFromBlock(blocks[0]);
      section.classList.remove(classes.playSection);
      section.classList.add(classes.resetSection);
      callNextFrame.push(function () {
        section.classList.remove(classes.resetSection);
      });
    } else {
      blocks.forEach(function (block, blockIndex) {
        // Set sequence for blocks
        block.style.setProperty('--pxu-lia-outer-sequence', blockIndex); // Set sequence for sub elements (heading, text, button, etc)
  
        var elements = block.querySelectorAll(".".concat(classes.element));
        elements.forEach(function (element, elementIndex) {
          element.style.setProperty('--pxu-lia-inner-sequence', elementIndex);
        });
  
        if (block.classList.contains(classes.playBlock)) {
          reset(block, elements);
          callNextFrame.push(function () {
            removeReset(block, elements);
            play(block, elements);
          });
        } else {
          play(block, elements);
        }
  
        var section = getMappingParentFromBlock(blocks[0]);
  
        if (section.classList.contains(classes.playSection)) {
          section.classList.add(classes.resetSection);
          callNextFrame.push(function () {
            section.classList.remove(classes.resetSection);
            section.classList.add(classes.playSection);
          });
        } else {
          section.classList.add(classes.playSection);
        }
      });
    }
  
    window.requestAnimationFrame(function () {
      return callNextFrame.forEach(function (fn) {
        return fn();
      });
    });
  };
  /**
   * Manually trigger load-in animations. Existing animations will be reset and replayed.
   *
   * @param {[HTMLElement]} blocks Blocks for which to play animations
   */
  
  
  var playLoadInAnimations = function playLoadInAnimations(blocks) {
    return loadInAnimations(blocks, 'play');
  };
  /**
   * Manually reset load-in animations to initial state.
   *
   * @param {[HTMLElement]} blocks Blocks for which to reset animations
   */
  
  
  var resetLoadInAnimations = function resetLoadInAnimations(blocks) {
    return loadInAnimations(blocks, 'reset');
  };
  
  var intersectionCallback = function intersectionCallback(entries, observer) {
    var toAnimate = new Map();
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        // Animations only run once so stop observing
        observer.unobserve(entry.target); // Find all blocks on same level that are now intersecting and arrange by parent section
  
        var parentSequence = getMappingParentFromBlock(entry.target);
        var existingSiblings = toAnimate.get(parentSequence);
        toAnimate.set(parentSequence, existingSiblings ? [].concat(_toConsumableArray(existingSiblings), [entry.target]) : [entry.target]);
      }
    });
    toAnimate.forEach(function (blocks, parent) {
      return playLoadInAnimations(blocks, parent);
    });
  };
  
  var blockObserver = null;
  /**
   * Removes blocks from the global intersection observer for load in animations.
   *
   * @param {[HTMLElement]} blocks Blocks to stop observing for automatic load-in-animation play
   */
  
  var removeLoadInAnimationsAutoplay = function removeLoadInAnimationsAutoplay(blocks) {
    return blocks.forEach(function (block) {
      return blockObserver && blockObserver.unobserve(block);
    });
  };
  
  var initLoadInAnimationsAutoplay = function initLoadInAnimationsAutoplay() {
    // This assumes that animated elements are arranged by section,
    // block, and element. Animations are triggered when blocks
    // enter view, and are sequenced within sections by block and by subElement.
    // Sequencing information is applied as custom properties that can be referenced in css.
    blockObserver = new IntersectionObserver(intersectionCallback, {
      threshold: 0.3
    });
  
    if (!('reduceAnimations' in document.body.dataset)) {
      var observe = function observe(parent) {
        parent.querySelectorAll(".".concat(classes.block)).forEach(function (block) {
          return blockObserver.observe(block);
        });
      };
  
      observe(document);
    }
  };
  
  
  
  /***/ }),
  /* 5 */,
  /* 6 */,
  /* 7 */
  /***/ (function(module, __webpack_exports__, __webpack_require__) {
  
  "use strict";
  // ESM COMPAT FLAG
  __webpack_require__.r(__webpack_exports__);
  
  // EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
  var jquery = __webpack_require__(0);
  var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);
  
  // CONCATENATED MODULE: ./source/scripts/globals/jquery.js
  // jQuery plugins expect to find a global `jQuery` object, so we
  // need to attach it to the window.
  //
  // This is in its own file because we have to attach it before any
  // other imports happen, but with ES6 modules, all `import`s have
  // to be at the top.
  
  window.jQuery = jquery_default.a;
  window.$ = jquery_default.a;
  // EXTERNAL MODULE: ./node_modules/jquery-trend/jquery.trend.js
  var jquery_trend = __webpack_require__(5);
  
  // EXTERNAL MODULE: ./node_modules/jquery-revealer/jquery.revealer.js
  var jquery_revealer = __webpack_require__(6);
  
  // EXTERNAL MODULE: ./node_modules/scriptjs/dist/script.js
  var script = __webpack_require__(1);
  var script_default = /*#__PURE__*/__webpack_require__.n(script);
  
  // EXTERNAL MODULE: ./node_modules/rimg-shopify/dist/index.es.js + 1 modules
  var index_es = __webpack_require__(2);
  
  // CONCATENATED MODULE: ./source/scripts/Sections.js
  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
  
  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
  
  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  
  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
  
  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
  
  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
  
  /**
   * Allows a callback to be run once, when a target intersects the viewport.
   * @constructor
   * @param {Object} [options] options with which to construct the IntersectionObserver
   * @param {string} [options.rootMargin='30%'] A string which specifies a set of offsets to add to
   *                                          the root's bounding_box when calculating intersections.
   * @param {number} [options.threshold=0] Ratio of intersection required to trigger callback
   */
  var LazyLoader = /*#__PURE__*/function () {
    function LazyLoader(options) {
      _classCallCheck(this, LazyLoader);
  
      var defaultOptions = {
        rootMargin: '30%',
        threshold: 0
      };
      this.callbacks = new WeakMap();
      this._observerCallback = this._observerCallback.bind(this);
      this.observer = new IntersectionObserver(this._observerCallback, _objectSpread(_objectSpread({}, defaultOptions), options));
    }
    /**
     * Add target and callback. Callback is only run once.
     * @add
     * @param {HTMLElement} target Target element
     * @param {function} callback Callback to run when target begins intersecting
     */
  
  
    _createClass(LazyLoader, [{
      key: "add",
      value: function add(target, callback) {
        this.callbacks.set(target, callback);
        this.observer.observe(target);
      }
      /**
       * Remove target. Associated callback is also removed.
       * @remove
       * @param {HTMLElement} target Target element
       */
  
    }, {
      key: "remove",
      value: function remove(target) {
        this.observer.unobserve(target);
        this.callbacks.delete(target);
      }
      /**
       * Disconnects IntersectionObserver if active
       * @unload
       */
  
    }, {
      key: "unload",
      value: function unload() {
        this.observer.disconnect();
      }
      /**
       * Runs associated callbacks for each entry, then removes that entry and callback
       * @_observerCallback
       * @param {IntersectionObserverEntry[]} entries Entries to check
       * @param {InterserctionObserver} observer IntersectionObserver instance
       */
  
    }, {
      key: "_observerCallback",
      value: function _observerCallback(entries, observer) {
        var _this = this;
  
        entries.forEach(function (_ref) {
          var isIntersecting = _ref.isIntersecting,
              target = _ref.target;
  
          // do nothing unless target moved into state of intersection
          if (isIntersecting === true) {
            // make sure we stop observing before running the callback, so we don't
            // somehow run the callback twice if element intersects twice quickly
            observer.unobserve(target);
  
            var callback = _this.callbacks.get(target);
  
            if (typeof callback === 'function') {
              callback();
            }
  
            _this.callbacks.delete(target);
          }
        });
      }
    }]);
  
    return LazyLoader;
  }();
  
  var Sections = /*#__PURE__*/function () {
    function Sections() {
      _classCallCheck(this, Sections);
  
      this.handlers = {};
      this.instances = {};
      this.options = {};
      this.imports = {};
      this.lazyLoader = null;
      this._onSectionEvent = this._onSectionEvent.bind(this);
      document.addEventListener('shopify:section:load', this._onSectionEvent);
      document.addEventListener('shopify:section:unload', this._onSectionEvent);
      document.addEventListener('shopify:section:select', this._onSectionEvent);
      document.addEventListener('shopify:section:deselect', this._onSectionEvent);
      document.addEventListener('shopify:block:select', this._onSectionEvent);
      document.addEventListener('shopify:block:deselect', this._onSectionEvent);
    }
    /**
     * Stop listening for section events, and unbind all handlers.
     */
  
  
    _createClass(Sections, [{
      key: "unbind",
      value: function unbind() {
        document.removeEventListener('shopify:section:load', this._onSectionEvent);
        document.removeEventListener('shopify:section:unload', this._onSectionEvent);
        document.removeEventListener('shopify:section:select', this._onSectionEvent);
        document.removeEventListener('shopify:section:deselect', this._onSectionEvent);
        document.removeEventListener('shopify:block:select', this._onSectionEvent);
        document.removeEventListener('shopify:block:deselect', this._onSectionEvent); // Unload all instances
  
        for (var i = 0; i < this.instances.length; i++) {
          this._triggerInstanceEvent(this.instances[i], 'onSectionUnload');
        }
  
        this.handlers = {};
        this.options = {};
        this.lazyLoader.unload();
        this.lazyLoader = null;
        this.instances = {};
      }
      /**
       * Register a section handler.
       *
       * @param {string} type
       *        The section type to handle. The handler will be called for all
       *        sections with this type.
       *
       * @param {function} handler
       *        The handler function is passed information about a specific section
       *        instance. The handler is expected to return an object that will be
       *        associated with the section instance.
       *
       *        Section handlers are passed an object with the following parameters:
       *          {string} id
       *          An ID that maps to a specific section instance. Typically the
       *          section's filename for static sections, or a generated ID for
       *          dynamic sections.
       *
       *          {string} type
       *          The section type, as supplied when registered.
       *
       *          {Element} el
       *          The root DOM element for the section instance.
       *
       *          {Object} data
       *          Data loaded from the section script element. Defaults to an
       *          empty object.
       *
       *          {Function} postMessage
       *          A function that can be called to pass messages between sections.
       *          The function should be called with a message "name", and
       *          optionally some data.
       *
       * @param {object} options
       *
       * @param {boolean} options.lazy
       *     If true, sections will only be initialized after they intersect the viewport + 30% margin
       */
  
    }, {
      key: "register",
      value: function register(type, handler) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  
        if (this.handlers[type]) {
          console.warn("Sections: section handler already exists of type '".concat(type, "'."));
        } // Store the section handler
  
  
        this.handlers[type] = handler; // Store options
  
        this.options[type] = options; // Init sections for this type
  
        this._initSections(type);
      }
      /**
       * Initialize sections already on the page.
       */
  
    }, {
      key: "_initSections",
      value: function _initSections(type) {
        var _this2 = this;
  
        // Fetch all existing sections of our type on the page
        var dataEls = document.querySelectorAll("[data-section-type=\"".concat(type, "\"]"));
        if (!dataEls) return; // Create an instance for each section
  
        var _loop = function _loop(i) {
          var dataEl = dataEls[i];
          var el = dataEl.parentNode; // Get instance ID
  
          var idEl = el.querySelector('[data-section-id]');
  
          if (!idEl) {
            console.warn("Sections: unable to find section id for '".concat(type, "'."), el);
            return "continue"; // eslint-disable-line no-continue
          }
  
          var sectionId = idEl.getAttribute('data-section-id');
  
          if (!sectionId) {
            console.warn("Sections: unable to find section id for '".concat(type, "'."), el);
            return "continue"; // eslint-disable-line no-continue
          }
  
          if (_this2.options[type] && _this2.options[type].lazy) {
            if (_this2.lazyLoader === null) {
              _this2.lazyLoader = new LazyLoader();
            }
  
            _this2.lazyLoader.add(el, function () {
              return _this2._createInstance(sectionId, el);
            });
          } else {
            _this2._createInstance(sectionId, el);
          }
        };
  
        for (var i = 0; i < dataEls.length; i++) {
          var _ret = _loop(i);
  
          if (_ret === "continue") continue;
        }
      }
    }, {
      key: "_onSectionEvent",
      value: function _onSectionEvent(event) {
        var el = event.target;
        var _event$detail = event.detail,
            sectionId = _event$detail.sectionId,
            blockId = _event$detail.blockId;
        var instance = this.instances[sectionId];
  
        switch (event.type) {
          case 'shopify:section:load':
            this._createInstance(sectionId, el);
  
            break;
  
          case 'shopify:section:unload':
            this._triggerInstanceEvent(instance, 'onSectionUnload', {
              el: el,
              id: sectionId
            });
  
            if (this.lazyLoader) {
              this.lazyLoader.remove(el);
            }
  
            delete this.instances[sectionId];
            break;
  
          case 'shopify:section:select':
            this._triggerInstanceEvent(instance, 'onSectionSelect', {
              el: el,
              id: sectionId
            });
  
            break;
  
          case 'shopify:section:deselect':
            this._triggerInstanceEvent(instance, 'onSectionDeselect', {
              el: el,
              id: sectionId
            });
  
            break;
  
          case 'shopify:block:select':
            this._triggerInstanceEvent(instance, 'onSectionBlockSelect', {
              el: el,
              id: blockId
            });
  
            break;
  
          case 'shopify:block:deselect':
            this._triggerInstanceEvent(instance, 'onSectionBlockDeselect', {
              el: el,
              id: blockId
            });
  
            break;
  
          default:
            break;
        }
      }
    }, {
      key: "_triggerInstanceEvent",
      value: function _triggerInstanceEvent(instance, eventName) {
        if (instance && instance[eventName]) {
          for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }
  
          instance[eventName].apply(instance, args);
        }
      }
    }, {
      key: "_postMessage",
      value: function _postMessage(name, data) {
        var _this3 = this;
  
        Object.keys(this.instances).forEach(function (id) {
          _this3._triggerInstanceEvent(_this3.instances[id], 'onSectionMessage', name, data);
        });
      }
    }, {
      key: "_createInstance",
      value: function _createInstance(id, el) {
        var _this4 = this;
  
        var typeEl = el.querySelector('[data-section-type]');
        if (!typeEl) return;
        var type = typeEl.getAttribute('data-section-type');
        if (!type) return;
        var handler = this.handlers[type];
  
        if (!handler) {
          console.warn("Sections: unable to find section handler for type '".concat(type, "'."));
          return;
        }
  
        var data = this._loadData(el);
  
        var postMessage = this._postMessage.bind(this);
  
        var handlerParams = {
          id: id,
          type: type,
          el: el,
          data: data,
          postMessage: postMessage
        };
  
        if (!this.imports[type]) {
          handler().then(function (_ref2) {
            var Component = _ref2.default;
            _this4.imports[type] = Component;
            _this4.instances[id] = new Component(handlerParams);
          });
        } else {
          this.instances[id] = new this.imports[type](handlerParams);
        }
      }
    }, {
      key: "_loadData",
      value: function _loadData(el) {
        var dataEl = el.querySelector('[data-section-data]');
        if (!dataEl) return {}; // Load data from attribute, or innerHTML
  
        var data = dataEl.getAttribute('data-section-data') || dataEl.innerHTML;
  
        try {
          return JSON.parse(data);
        } catch (error) {
          console.warn("Sections: invalid section data found. ".concat(error.message));
          return {};
        }
      }
    }]);
  
    return Sections;
  }();
  
  
  // CONCATENATED MODULE: ./source/scripts/checkPolyfills.js
  var polyfillUrls = []; // Checks if all IntersectionObserver and IntersectionObserverEntry
  // features are natively supported.
  
  if (!('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
    polyfillUrls.push(document.querySelector('[data-scripts]').dataset.pxuPolyfills);
  } // Polyfill NodeList.forEach if required.
  // Polyfill is so small it doesn't need to load any external code.
  
  
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
  
  if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
      var el = this;
  
      do {
        if (Element.prototype.matches.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
      } while (el !== null && el.nodeType === 1);
  
      return null;
    };
  }
  
  /* harmony default export */ var checkPolyfills = (polyfillUrls);
  // CONCATENATED MODULE: ./source/scripts/helpers/FlickityTouchFix.js
  // This is a helper class to fix a touch issue that came up in flickity
  // on iOS devices as of version 13. It should smooth out some of the scroll
  // and swipe issues that flickity is having on that version of iOS.
  var flickityTouchFix = function flickityTouchFix() {
    var touchingSlider = false;
    var touchStartCoordsX = 0;
  
    var onTouchStart = function onTouchStart(e) {
      if (e.target.closest && e.target.closest('.flickity-slider')) {
        touchingSlider = true;
        touchStartCoordsX = e.touches[0].pageX;
      } else {
        touchingSlider = false;
      }
    };
  
    var onTouchMove = function onTouchMove(e) {
      if (!(touchingSlider && e.cancelable)) {
        return;
      }
  
      if (Math.abs(e.touches[0].pageX - touchStartCoordsX) > 10) {
        e.preventDefault();
      }
    };
  
    document.body.addEventListener('touchstart', onTouchStart);
    document.body.addEventListener('touchmove', onTouchMove, {
      passive: false
    });
  };
  
  /* harmony default export */ var FlickityTouchFix = (flickityTouchFix);
  // EXTERNAL MODULE: ./source/scripts/helpers/Ripple.js
  var Ripple = __webpack_require__(3);
  
  // EXTERNAL MODULE: ./source/scripts/helpers/LoadInAnimations.js
  var LoadInAnimations = __webpack_require__(4);
  
  // CONCATENATED MODULE: ./source/scripts/Empire.js
  // jQuery plugins
  
   // eslint-disable-line
  
   // eslint-disable-line
  // Global imports
  
   // Responsive Images
  
   // eslint-disable-line
  // Section Manager
  
   // Polyfills
  
   // Flickity iOS fix
  
  
  
  
  
  var Empire_initEmpire = function initEmpire() {
    Object(LoadInAnimations["a" /* initLoadInAnimationsAutoplay */])();
    index_es["a" /* default */].init('[data-rimg="lazy"]', {
      round: 1
    });
    Object(Ripple["a" /* setupRippleEffect */])(document);
    var sections = new Sections(); // Static sections
  
    sections.register('static-announcement', function () {
      return __webpack_require__.e(/* import() | StaticAnnouncement */ 22).then(__webpack_require__.bind(null, 59));
    });
    sections.register('static-footer', function () {
      return __webpack_require__.e(/* import() | StaticFooter */ 27).then(__webpack_require__.bind(null, 87));
    });
    sections.register('static-article', function () {
      return __webpack_require__.e(/* import() | StaticArticle */ 23).then(__webpack_require__.bind(null, 60));
    });
    sections.register('static-blog', function () {
      return __webpack_require__.e(/* import() | StaticBlog */ 24).then(__webpack_require__.bind(null, 61));
    });
    sections.register('static-cart', function () {
      return Promise.all(/* import() | StaticCart */[__webpack_require__.e(37), __webpack_require__.e(25)]).then(__webpack_require__.bind(null, 62));
    });
    sections.register('static-collection', function () {
      return Promise.all(/* import() | StaticCollection */[__webpack_require__.e(0), __webpack_require__.e(2), __webpack_require__.e(1), __webpack_require__.e(3), __webpack_require__.e(26)]).then(__webpack_require__.bind(null, 63));
    });
    sections.register('static-password', function () {
      return __webpack_require__.e(/* import() | StaticPassword */ 30).then(__webpack_require__.bind(null, 64));
    });
    sections.register('static-product', function () {
      return Promise.all(/* import() | StaticProduct */[__webpack_require__.e(0), __webpack_require__.e(2), __webpack_require__.e(1), __webpack_require__.e(31)]).then(__webpack_require__.bind(null, 65));
    });
    sections.register('static-product-recommendations', function () {
      return Promise.all(/* import() | StaticProductRecommendations */[__webpack_require__.e(0), __webpack_require__.e(2), __webpack_require__.e(1), __webpack_require__.e(3), __webpack_require__.e(32)]).then(__webpack_require__.bind(null, 88));
    });
    sections.register('static-recently-viewed', function () {
      return Promise.all(/* import() | StaticRecentlyViewed */[__webpack_require__.e(0), __webpack_require__.e(33)]).then(__webpack_require__.bind(null, 66));
    });
    sections.register('static-search', function () {
      return Promise.all(/* import() | StaticSearch */[__webpack_require__.e(0), __webpack_require__.e(2), __webpack_require__.e(1), __webpack_require__.e(3), __webpack_require__.e(34)]).then(__webpack_require__.bind(null, 67));
    });
    sections.register('static-highlights-banners', function () {
      return Promise.all(/* import() | StaticHighlightsBanners */[__webpack_require__.e(0), __webpack_require__.e(29)]).then(__webpack_require__.bind(null, 68));
    });
    sections.register('static-slideshow', function () {
      return Promise.all(/* import() | StaticSlideshow */[__webpack_require__.e(0), __webpack_require__.e(35)]).then(__webpack_require__.bind(null, 69));
    }, {
      lazy: true
    }); // Dynamic sections (lazy loaded)\
  
    sections.register('dynamic-blog-posts', function () {
      return Promise.all(/* import() | DynamicBlogPosts */[__webpack_require__.e(0), __webpack_require__.e(9)]).then(__webpack_require__.bind(null, 70));
    }, {
      lazy: true
    });
    sections.register('dynamic-promo-mosaic', function () {
      return __webpack_require__.e(/* import() | DynamicPromoBlocks */ 14).then(__webpack_require__.bind(null, 71));
    }, {
      lazy: true
    });
    sections.register('dynamic-promo-grid', function () {
      return __webpack_require__.e(/* import() | DynamicPromoBlocks */ 14).then(__webpack_require__.bind(null, 71));
    }, {
      lazy: true
    });
    sections.register('dynamic-menu-list', function () {
      return __webpack_require__.e(/* import() | DynamicMenuList */ 11).then(__webpack_require__.bind(null, 72));
    }, {
      lazy: true
    });
    sections.register('dynamic-twitter-feed', function () {
      return Promise.all(/* import() | DynamicTwitterFeed */[__webpack_require__.e(0), __webpack_require__.e(17)]).then(__webpack_require__.bind(null, 73));
    }, {
      lazy: true
    });
    sections.register('dynamic-featured-collection', function () {
      return Promise.all(/* import() | DynamicFeaturedCollection */[__webpack_require__.e(0), __webpack_require__.e(2), __webpack_require__.e(1), __webpack_require__.e(3), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, 74));
    }, {
      lazy: true
    });
    sections.register('dynamic-featured-product', function () {
      return Promise.all(/* import() | DynamicProduct */[__webpack_require__.e(0), __webpack_require__.e(2), __webpack_require__.e(1), __webpack_require__.e(13)]).then(__webpack_require__.bind(null, 75));
    }, {
      lazy: true
    });
    sections.register('dynamic-rich-text', function () {
      return __webpack_require__.e(/* import() | DynamicRichText */ 15).then(__webpack_require__.bind(null, 76));
    }, {
      lazy: true
    });
    sections.register('dynamic-html', function () {
      return __webpack_require__.e(/* import() | DynamicRichText */ 15).then(__webpack_require__.bind(null, 76));
    }, {
      lazy: true
    });
    sections.register('dynamic-search', function () {
      return Promise.all(/* import() | DynamicSearch */[__webpack_require__.e(5), __webpack_require__.e(4), __webpack_require__.e(16)]).then(__webpack_require__.bind(null, 77));
    }, {
      lazy: true
    });
    sections.register('dynamic-video', function () {
      return __webpack_require__.e(/* import() | DynamicVideo */ 18).then(__webpack_require__.bind(null, 78));
    }, {
      lazy: true
    });
    sections.register('pxs-newsletter', function () {
      return __webpack_require__.e(/* import() | DynamicNewsletter */ 12).then(__webpack_require__.bind(null, 79));
    }, {
      lazy: true
    });
    sections.register('pxs-map', function () {
      return __webpack_require__.e(/* import() | PXSMap */ 20).then(__webpack_require__.bind(null, 80));
    }, {
      lazy: true
    });
  
    if (document.body.classList.contains('template-giftcard')) {
      __webpack_require__.e(/* import() | GiftCard */ 19).then(__webpack_require__.bind(null, 81)).then(function (_ref) {
        var GiftCard = _ref.default;
        return new GiftCard();
      });
    }
  
    if (document.querySelector('[data-template-account]')) {
      __webpack_require__.e(/* import() | Account */ 6).then(__webpack_require__.bind(null, 82)).then(function (_ref2) {
        var Account = _ref2.default;
        return new Account();
      });
    }
  
    if (document.body.classList.contains('template-contact')) {
      __webpack_require__.e(/* import() | Contact */ 7).then(__webpack_require__.bind(null, 83)).then(function (_ref3) {
        var Contact = _ref3.default;
        return new Contact();
      });
    }
  
    if (document.body.classList.contains('template-page')) {
      __webpack_require__.e(/* import() | Page */ 21).then(__webpack_require__.bind(null, 84)).then(function (_ref4) {
        var Page = _ref4.default;
        return new Page();
      });
    }
  
    if (document.querySelector('[data-swatch-tooltip]')) {
      __webpack_require__.e(/* import() | ContainSwatchTooltips */ 8).then(__webpack_require__.bind(null, 85)).then(function (_ref5) {
        var ContainSwatchTooltips = _ref5.default;
        return new ContainSwatchTooltips();
      });
    }
  };
  
  FlickityTouchFix();
  
  if (checkPolyfills.length) {
    script_default()(checkPolyfills, Empire_initEmpire);
  } else {
    Empire_initEmpire();
  }
  
  /***/ })
  /******/ ]);